// extracted by mini-css-extract-plugin
export default {"image":"HHEWN7"};